class ReadinessService {
  get_readiness(page, data) {
    return axios.post('general/readiness_report?page=' + page, data)
  }
  edit_readines(id) {
    return axios.get('general/readiness_report/details/' + id)
  }
  get_readiness_create() {
    return axios.get('general/readiness_report/create')
  }
  create_readines(data) {
    return axios.post('general/readiness_report/store', data)
  }
  add_readines(data) {
    return axios.post('general/readiness_report/store', data)
  }
  reject_readines(data) {
    return axios.post('general/readiness_report/reject_assignation', data)
  }
  upload_docs(data) {
    return axios.post('general/readiness_report/upload_docs', data)
  }
  update_docs(data) {
    return axios.post('general/readiness_report/store_update', data)
  }
  cancel_readiness(data) {
    return axios.post('general/readiness_report/cancel_report', data)
  }
  reject_assignation(data) {
    return axios.post('general/readiness_report/reject_assignation', data)
  }
  change_assignation(data) {
    return axios.post('general/readiness_report/change_assignation', data)
  }
  assign_contractor(data) {
    return axios.post('general/readiness_report/assign_contractor', data)
  }
  get_entities() {
    return axios.get('general/readiness_report/get_entities')
  }
  get_contractors() {
    return axios.get('general/readiness_report/get_contractors')
  }

  change_status(data) {
    return axios.post('general/readiness_report/change_status', data)
  }


}
export default new ReadinessService();
